import { type IDataObjectsState } from '@inpart-io/devtools-vue';
import { type ITemplateDealStage } from '@inpart-io/padme-iap';
import { type GetterTree } from 'vuex';

export const GET_TEMPLATES_BY_DEAL_TYPE = 'getTemplatesByDealType';

export const getters: GetterTree<IDataObjectsState<ITemplateDealStage>, unknown> = {
    [GET_TEMPLATES_BY_DEAL_TYPE]: (_state) => {
        return (dealTypeId: number): ITemplateDealStage[] => {
            if (dealTypeId !== null && dealTypeId !== undefined) {
                return (
                    Array.from(_state.dataObjectList.values())
                        ?.filter((tds: ITemplateDealStage) => {
                            return tds.onDealType === dealTypeId;
                        })
                        ?.sort((a, b) => {
                            return a.position - b.position;
                        }) ?? []
                );
            } else {
                return [];
            }
        };
    }
};
